import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./FaqSection.css";

const faqItems = [
  {
    id: "faq-about-monayra",
    icon: "bi bi-building-check",
    question:
      "What is Monayra Solutions India Pvt. Ltd. and how can it help me?",
    answer: (
      <>
        <p>
          Monayra is a loan assistance and financial consulting company that
          helps customers explore suitable loan options from leading banks and
          financial institutions.
        </p>

        <p>
          Our team supports customers with lender comparison, documentation,
          application processing, regular follow-ups and loan disbursement.
        </p>
      </>
    ),
  },
  {
    id: "faq-loan-products",
    icon: "bi bi-grid",
    question: "Which loan products are available through Monayra?",
    answer: (
      <>
        <p>Monayra assists customers with the following loan products:</p>

        <ul>
          <li>Home Loan</li>
          <li>Home Loan Balance Transfer</li>
          <li>Loan Against Property</li>
          <li>Commercial Loan</li>
          <li>Personal Loan</li>
          <li>Business Loan</li>
          <li>Car Loan</li>
          <li>Education Loan</li>
        </ul>
      </>
    ),
  },
  {
    id: "faq-apply",
    icon: "bi bi-file-earmark-text",
    question: "How can I apply for a loan?",
    answer: (
      <>
        <p>
          You can submit your loan enquiry through the Monayra website by
          visiting the Apply Now page.
        </p>

        <p>
          After receiving your application, our team will contact you, review
          your requirements and guide you through the required documents and
          lender process.
        </p>

        <Link to="/apply-now" className="faq-inline-link">
          Apply for a loan
          <i className="bi bi-arrow-right"></i>
        </Link>
      </>
    ),
  },
  {
    id: "faq-interest-rate",
    icon: "bi bi-percent",
    question: "What interest rate will I receive on my loan?",
    answer: (
      <>
        <p>
          The final interest rate depends on the selected lender, loan product,
          applicant income, employment profile, credit score, existing
          obligations, property details and prevailing lender policies.
        </p>

        <p>
          Monayra helps customers compare suitable offers from available
          lending partners. The displayed starting rates are indicative and do
          not guarantee final approval at the same rate.
        </p>
      </>
    ),
  },
  {
    id: "faq-bank-charges",
    icon: "bi bi-receipt",
    question: "Does Monayra provide support with applicable bank charges?",
    answer: (
      <>
        <p>
          On selected eligible loan cases, applicable bank charges may be paid
          by Monayra at the time of disbursement, subject to the sanctioned loan
          amount, selected bank, applicable offer and internal terms.
        </p>

        <p>
          The exact eligible charges and percentage of support will be
          communicated before the loan process is completed.
        </p>
      </>
    ),
  },
  {
    id: "faq-process",
    icon: "bi bi-diagram-3",
    question: "What is the general loan application process?",
    answer: (
      <ol>
        <li>Submit your loan enquiry through the website.</li>
        <li>Our team contacts you to understand your requirement.</li>
        <li>Required financial and property documents are collected.</li>
        <li>Suitable bank and loan options are compared.</li>
        <li>The application is submitted to the selected lender.</li>
        <li>The lender completes verification and credit assessment.</li>
        <li>After approval, the case proceeds towards disbursement.</li>
      </ol>
    ),
  },
  {
    id: "faq-documents",
    icon: "bi bi-folder-check",
    question: "Which documents are generally required?",
    answer: (
      <>
        <p>
          Required documents vary according to the loan product and applicant
          profile. Common documents may include:
        </p>

        <ul>
          <li>PAN card and Aadhaar card</li>
          <li>Recent salary slips or income proof</li>
          <li>Bank statements</li>
          <li>Income tax returns, where applicable</li>
          <li>Employment or business proof</li>
          <li>Property documents for secured loans</li>
          <li>Existing loan statements for balance transfer</li>
        </ul>
      </>
    ),
  },
  {
    id: "faq-approval-time",
    icon: "bi bi-clock-history",
    question: "How long does loan approval take?",
    answer: (
      <>
        <p>
          Approval time depends on document completeness, applicant profile,
          lender verification, property valuation and legal checks.
        </p>

        <p>
          Complete and accurate documents can help reduce delays. Monayra
          follows up with the concerned lender and keeps the customer informed
          throughout the process.
        </p>
      </>
    ),
  },
];

function FaqSection() {
  const [openFaq, setOpenFaq] = useState(faqItems[0].id);

  const toggleFaq = (faqId) => {
    setOpenFaq((currentFaq) =>
      currentFaq === faqId ? null : faqId
    );
  };

  return (
    <section
      className="faq-section"
      aria-labelledby="faq-section-title"
    >
      <div
        className="faq-background-glow faq-glow-left"
        aria-hidden="true"
      ></div>

      <div
        className="faq-background-glow faq-glow-right"
        aria-hidden="true"
      ></div>

      <div className="faq-section-container">
        <div className="faq-section-header">
          <span className="faq-section-eyebrow">
            Common Questions
          </span>

          <h2 id="faq-section-title">
            Frequently asked questions about
            <span> loans and our services</span>
          </h2>

          <p>
            Find answers about loan products, application steps, documents,
            interest rates and Monayra’s assistance process.
          </p>
        </div>

        <div className="faq-layout">
          <div className="faq-list">
            {faqItems.map((faq, index) => {
              const isOpen = openFaq === faq.id;

              return (
                <article
                  className={`faq-item ${isOpen ? "open" : ""}`}
                  key={faq.id}
                >
                  <button
                    type="button"
                    className="faq-question"
                    onClick={() => toggleFaq(faq.id)}
                    aria-expanded={isOpen}
                    aria-controls={`${faq.id}-answer`}
                  >
                    <span className="faq-question-icon">
                      <i className={faq.icon}></i>
                    </span>

                    <span className="faq-question-content">
                      <span className="faq-question-number">
                        {String(index + 1).padStart(2, "0")}
                      </span>

                      <span className="faq-question-text">
                        {faq.question}
                      </span>
                    </span>

                    <span className="faq-toggle-icon">
                      <i
                        className={
                          isOpen
                            ? "bi bi-dash-lg"
                            : "bi bi-plus-lg"
                        }
                      ></i>
                    </span>
                  </button>

                  <div
                    id={`${faq.id}-answer`}
                    className="faq-answer-wrapper"
                    hidden={!isOpen}
                  >
                    <div className="faq-answer">
                      {faq.answer}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          <aside className="faq-support-card">
            <div className="faq-support-card-glow"></div>

            <span className="faq-support-icon">
              <i className="bi bi-headset"></i>
            </span>

            <span className="faq-support-eyebrow">
              Need More Assistance?
            </span>

            <h3>Speak with a Monayra loan expert</h3>

            <p>
              Share your loan requirement and our team will guide you through
              suitable options, eligibility and documentation.
            </p>

            <Link
              to="/contact"
              className="faq-support-primary-btn"
            >
              <span>Contact Our Team</span>
              <i className="bi bi-arrow-right"></i>
            </Link>

            <Link
              to="/apply-now"
              className="faq-support-secondary-btn"
            >
              <i className="bi bi-file-earmark-text"></i>
              Apply Online
            </Link>

            <div className="faq-support-features">
              <div>
                <i className="bi bi-check-circle"></i>
                Professional assistance
              </div>

              <div>
                <i className="bi bi-check-circle"></i>
                Multiple lending partners
              </div>

              <div>
                <i className="bi bi-check-circle"></i>
                Doorstep document support
              </div>
            </div>
          </aside>
        </div>

        <div className="faq-disclaimer">
          <i className="bi bi-info-circle"></i>

          <p>
            Loan approval, interest rates, tenure, eligible amount and charges
            are determined by the selected lender based on its policies and
            the applicant’s financial profile.
          </p>
        </div>
      </div>
    </section>
  );
}

export default FaqSection;